// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "customer_id",
                Decco.intToJson(v.customer_id)
              ],
              [
                "wallet_balance",
                Decco.floatToJson(v.wallet_balance)
              ],
              [
                "update_amount",
                Decco.floatToJson(v.update_amount)
              ],
              [
                "updated_at",
                Decco.floatToJson(v.updated_at)
              ]
            ]);
}

export {
  t_encode ,
  
}
/* No side effect */
